import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TradePairState } from './tradepair.state';
import { tradePairFeatureKey } from './tradepair.reducers';

export const selectTradePairState = createFeatureSelector<TradePairState>(tradePairFeatureKey);

export const selectTradePair = createSelector(selectTradePairState, (state: TradePairState) => state);